import { useRef } from "react";
import { Button } from "../Button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";

type Props = {
  open: boolean;
  acceptedCount: number;
  busy: boolean;
  error?: string;
  onCancel: () => void;
  onConfirm: () => void;
  onCloseFocus?: () => boolean;
};

export function CloseResponsesDialog({ open, acceptedCount, busy, error, onCancel, onConfirm, onCloseFocus }: Props) {
  const previousFocus = useRef<HTMLElement | null>(null);

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen && !busy) onCancel(); }}>
      <DialogContent
        aria-busy={busy}
        onEscapeKeyDown={(event) => { if (busy) event.preventDefault(); }}
        onPointerDownOutside={(event) => { if (busy) event.preventDefault(); }}
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          previousFocus.current = document.activeElement as HTMLElement | null;
          document.getElementById("close-responses-cancel")?.focus();
        }}
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          const focusRedirected = onCloseFocus?.() ?? false;
          if (!focusRedirected) previousFocus.current?.focus();
          previousFocus.current = null;
        }}
      >
        <DialogTitle>Close responses?</DialogTitle>
        <DialogDescription>
          This stops new responses, keeps {acceptedCount} accepted {acceptedCount === 1 ? "perspective" : "perspectives"}, and finalises the Company View from that accepted evidence.
        </DialogDescription>
        {error && <div className="error-summary" role="alert">{error}</div>}
        <div className="button-row">
          <DialogClose asChild>
            <Button id="close-responses-cancel" variant="secondary" disabled={busy}>Cancel</Button>
          </DialogClose>
          <Button onClick={onConfirm} disabled={busy}>{busy ? "Closing responses…" : error ? "Try closing responses" : "Close responses"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
